import { formatCurrency } from "@sa-nu/shared-utils/price";

import type { SiteAvailabilityNight } from "../../../_hooks/use-site-availability";

/** `AvailabilityStrip` のタップ可能な日付セル。 */
export function AvailabilityStripDayCell({
  info,
  onSelect,
}: {
  info: SiteAvailabilityNight | undefined;
  onSelect: () => void;
}) {
  if (info === undefined) {
    return (
      <div
        data-testid="availability-cell-skeleton"
        className="bg-dx-surface-subtle h-[36px] w-full animate-pulse rounded-[2px]"
      />
    );
  }

  if (!info.isAvailable) {
    return (
      <div
        data-testid="availability-cell-full"
        className="bg-dx-bg-base-hover border-dx-border-default flex h-[36px] w-full items-center justify-center rounded-[2px] border"
      >
        <span className="font-notojp text-dx-text-tertiary text-[10px] leading-none">
          ✕
        </span>
      </div>
    );
  }

  const price = info.fromPrice != null && (
    <span className="font-notojp text-dx-text-default text-[10px] leading-none">
      {formatCurrency(info.fromPrice)}
    </span>
  );

  return (
    <button
      data-analytics-id="room_type_browse_selected_date"
      type="button"
      data-testid="availability-cell"
      onClick={onSelect}
      className="bg-dx-surface-base hover:bg-dx-bg-base-hover border-dx-border-default flex h-[36px] w-full items-center justify-center rounded-[2px] border transition-colors duration-150"
    >
      {price}
    </button>
  );
}
